export const defaults = {
    jsonUrl: "/globalassets/sweden/json/sat.json",
    id: null,
    siteKey: null,
    category: "",
    language: "en",
    invalidEmailText: "Invalid email",
    invalidPhoneText: "Invalid phone number",
    invalidNameText: "Please enter your name",
    invalidMarketingConsent: "Please indicate your marketing preference to continue",
    sendFailText: "Something went wrong, please try again later",
    firstNameFieldName: "ALL_First_Name",
    lastNameFieldName: "ALL_Last_Name",
    emailFieldName: "ALL_Email",
    countryCode: "All_Country_Code",
    phoneNumberFieldName: "ALL_Phone_Number_Smartphone",
    gaCidFieldName: "ga_cid",
    geoLocationFieldName: "ALL_Geo_city",
    sentFromPageFieldName: "sent_from_url",
    questionAnswersFieldName: "BEL_Question_and_Communication",
    title: "",
    text: "",
    gated: false,
    nameLabel: "Name",
    phoneNumberLabel: "Phone",
    emailLabel: "Email",
    submitText: "Show my result",
    backText: "Back",
    legalText: "",
    marketingConsent: "",
    sendSuccessText: "",
    requiredFieldsText: "Required fields",
    debug: false,
    skipPost: false,
    reasonOfContact: "",
    marketoCampaign: ""
};
